import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import SectionHeading from "@/components/feature/SectionHeading";
import NewsListItem from "@/components/feature/NewsListItem";
import { newsList } from "@/mocks/news";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function Article() {
  const { id = "" } = useParams();
  const item = newsList.find((n) => n.id === id);

  useDocumentMeta({
    title: item ? `${item.title} - 八戒影视资讯` : "资讯详情 - 八戒影视",
    description: item ? item.summary : "八戒影视资讯详情页，提供影视新闻、影评与幕后故事。",
    keywords: item ? `${item.category},影视资讯,${item.title}` : "影视资讯,八戒影视",
  });

  if (!item) {
    return (
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-16 text-center">
        <span className="inline-flex w-16 h-16 rounded-full bg-background-200 items-center justify-center text-foreground-400 mb-4">
          <i className="ri-article-line text-3xl"></i>
        </span>
        <h1 className="text-xl font-bold text-foreground-900">资讯不存在</h1>
        <p className="text-sm text-foreground-500 mt-2">这篇文章可能已被删除，或链接地址有误。</p>
        <Link
          to="/news/行业新闻"
          className="inline-block mt-5 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer"
        >
          返回资讯列表
        </Link>
      </div>
    );
  }

  const paragraphs = [
    item.summary,
    `${item.summary} 相关话题近期在影视爱好者中引发了不少讨论，不少观众表示希望看到更多同类型的优质内容。`,
    "从创作团队的角度来看，作品在筹备阶段就进行了大量的资料整理与调研。主创团队表示，他们希望用更贴近生活的方式，把故事的魅力传递给每一位观众。",
    "影视行业的每一次热度背后，都是内容、制作与观众需求共同作用的结果。八戒影视将持续关注行业动向，为你带来及时、可靠的影视资讯与深度解读。",
  ];

  const related = newsList.filter((n) => n.category === item.category && n.id !== item.id).slice(0, 3);

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-6 py-8">
      <Breadcrumb
        items={[
          { label: "首页", to: "/" },
          { label: "影视资讯", to: `/news/${item.category}` },
          { label: item.category, to: `/news/${item.category}` },
        ]}
      />

      <span className="inline-block px-2.5 py-1 rounded bg-secondary-100 text-secondary-800 text-xs font-medium">
        {item.category}
      </span>
      <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-3 leading-snug">{item.title}</h1>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs md:text-sm text-foreground-400 mt-4 pb-6 border-b border-background-200">
        <span>来源：{item.source}</span>
        <span>{item.date}</span>
      </div>

      <div className="w-full aspect-[16/9] rounded-lg overflow-hidden bg-background-200 my-6">
        <img
          src={item.image}
          alt={item.title}
          title={`${item.title} - 八戒影视资讯`}
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="space-y-4 text-sm md:text-base leading-relaxed text-foreground-700">
        {paragraphs.map((text, i) => (
          <p key={i}>{text}</p>
        ))}
      </div>

      <div className="mt-8 p-4 rounded-lg bg-background-100 border border-background-200 text-xs text-foreground-500">
        <i className="ri-information-line mr-1"></i>
        本文内容为演示数据，仅用于产品展示，不代表任何真实报道。
      </div>

      {related.length > 0 && (
        <section className="mt-12">
          <SectionHeading title="相关资讯" />
          <div className="rounded-lg border border-background-200 bg-background-50 px-4 md:px-5">
            {related.map((r) => (
              <NewsListItem key={r.id} item={r} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}